import { FC, useEffect, useState } from 'react';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, DatePicker, Button } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

interface TableFilterProps {
  createAssessment?: () => void;
  onFilterChange: (
    email: string,
    dateRange: [string, string] | undefined,
  ) => void;
  searchParam: string;
  dateRange: [string, string] | undefined;
  showDateRange?: boolean;
  searchPlaceholder?: string;
}
const TableFilter: FC<TableFilterProps> = ({
  createAssessment,
  onFilterChange,
  searchParam,
  dateRange,
  showDateRange = true,
  searchPlaceholder = 'Search email, name, phone',
}) => {
  const [debouncedSearchParam, setDebouncedSearchParam] = useState(searchParam);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onFilterChange(debouncedSearchParam, dateRange);
    }, 500);

    return () => clearTimeout(timeout);
  }, [debouncedSearchParam]);

  const handleSearchParamChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDebouncedSearchParam(e.target.value);
  };

  const handleDateChange = (dates: any, dateStrings: [string, string]) => {
    onFilterChange(
      debouncedSearchParam,
      dateStrings[0] && dateStrings[1] ? dateStrings : undefined,
    );
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current > dayjs().endOf('day');
  };

  const resetFilters = () => {
    setDebouncedSearchParam('');
    onFilterChange('', undefined);
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        justifyContent: 'flex-end',
      }}
    >
      <Input
        placeholder={searchPlaceholder}
        value={debouncedSearchParam}
        onChange={handleSearchParamChange}
        style={{ width: 250 }}
        suffix={<SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.3)' }} />}
      />
      {showDateRange && (
        <RangePicker
          value={dateRange ? [dayjs(dateRange[0]), dayjs(dateRange[1])] : null}
          onChange={handleDateChange}
          disabledDate={disabledDate}
        />
      )}
      <Button onClick={resetFilters} danger>
        Reset
      </Button>
      {createAssessment && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={createAssessment}
        >
          Create Assessment
        </Button>
      )}
    </div>
  );
};
export default TableFilter;
